module.exports = __webpack_public_path__ + "static/media/Figure3.2576ab28.jpg";